import { create } from 'zustand';
import type { Report } from '@shared/types';

export interface ReportState {
  reports: Report[];
  add(report: Report): void;
  reset(): void;
}

export const useReportStore = create<ReportState>((set) => ({
  reports: [],
  add: (report) => set((s) => ({ reports: [report, ...s.reports] })),
  reset: () => set({ reports: [] }),
}));

export default useReportStore;
